module.exports = __webpack_public_path__ + "static/img/7.e2d52a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/eng/7.png
// module id = CS9m
// module chunks = 0